import type { ReactNode, FC } from 'react';
import cn from 'classnames';
import PlainButtonOrLink from '@wix/da-ds/pkg/Buttons/PlainButtonOrLink';

import s from './StatItem.scss';

interface Props {
  title: ReactNode;
  value?: ReactNode;
  linkTo?: string;
  disabled?: boolean;
}

const StatItem: FC<Props> = ({ title, value, linkTo, disabled }) => {
  return (
    <div className={cn(s['root'], disabled && s['disabled'])}>
      <div className={s['stat-value']}>
        {disabled ? (
          '---'
        ) : linkTo ? (
          <PlainButtonOrLink className={s['stat-link']} href={linkTo}>
            {value}
          </PlainButtonOrLink>
        ) : (
          value
        )}
      </div>
      <div className={s['stat-title']}>{title}</div>
    </div>
  );
};
StatItem.displayName = 'StatItem';

export default StatItem;
